var DebugLevel;
(function (DebugLevel) {
    DebugLevel[DebugLevel["DEBUG"] = 6] = "DEBUG";
    DebugLevel[DebugLevel["NONE"] = 7] = "NONE";
})(DebugLevel || (DebugLevel = {}));
export default DebugLevel;
